import insertSorted from "../../utils/insertSorted";
import { ChatDetail } from "../ChatAction";

export function joinMessages(messages: readonly ChatDetail[], msg: ChatDetail): ChatDetail[] {
    return insertSorted([...messages], msg, (left, right) => left.timestamp - right.timestamp);
}
